import { useEffect, useState } from "react";
import { isUserAdmin } from "../helpers/firestoreService";
import { useAuthUser } from "./AuthProvider";

/**
 * Returns { isAdmin: bool, adminLoading: bool }.
 * Admin status is determined by the presence of a doc in the `admins` Firestore collection
 * where the document ID equals the user's UID.
 */
export function useAdmin() {
  const user = useAuthUser();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminLoading, setAdminLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsAdmin(false);
      setAdminLoading(false);
      return;
    }
    setAdminLoading(true);
    isUserAdmin(user.uid)
      .then(setIsAdmin)
      .catch(() => setIsAdmin(false))
      .finally(() => setAdminLoading(false));
  }, [user?.uid]);

  return { isAdmin, adminLoading };
}
